var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('button',{staticClass:"goTop",on:{"click":_vm.backToTop}},[_c('svg-icon',{attrs:{"icon-id":"arrow-up"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }